import { Map, List, fromJS } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { RESET_STORE } from 'constants/index'

// constants
export const LICENSEE_FETCH_LIST = 'licensee/FETCH_LIST'
export const LICENSEE_FETCH_LIST_BY_USER =
  'licensee/LICENSEE_FETCH_LIST_BY_USER'
export const [
  LICENSEE_FETCH_LIST_BY_USER_SUCCESS,
  LICENSEE_FETCH_LIST_BY_USER_FAILURE,
] = [
  `${LICENSEE_FETCH_LIST_BY_USER}_SUCCESS`,
  `${LICENSEE_FETCH_LIST_BY_USER}_FAILURE`,
]

export const LICENSEE_GET_TABLE_DATA = 'licensee/GET_TABLE_DATA'
export const LICENSEE_SET_TABLE_DATA = 'licensee/SET_TABLE_DATA'
export const LICENSEE_FETCH_FORM_DATA = 'licensee/FETCH_FORM_DATA'
export const LICENSEE_CHANGE = 'licensee/CHANGE'
export const LICENSEE_DELETE = 'licensee/DELETE'
export const LICENSEE_DISPLAY_TABLE = 'licensee/DISPLAY_TABLE'
export const LICENSEE_DISPLAY_FORM = 'licensee/DISPLAY_FORM'
export const LICENSEE_CLEAR_STATE = 'licensee/CLEAR_STATE'
export const LICENSEE_CLEAR_STATE_LIST = 'licensee/CLEAR_STATE_LIST'
export const LICENSEE_CLEAR_STATE_FORM = 'licensee/CLEAR_STATE_FORM'
export const LICENSEE_REDIRECT = 'licensee/REDIRECT'
export const CLEAR_CURRENT_LICENSEE = 'licensee/CLEAR_CURRENT_LICENSEE'
export const UPDATE_LICENSEE_LOGO = 'licensee/UPDATE_LICENSEE_LOGO'
export const [UPDATE_LICENSEE_LOGO_SUCCESS, UPDATE_LICENSEE_LOGO_FAILURE] = [
  `${UPDATE_LICENSEE_LOGO}_SUCCESS`,
  `${UPDATE_LICENSEE_LOGO}_FAILURE`,
]

// actions
export const licenseeFetchList = ActionHelper.createActionObj(
  LICENSEE_FETCH_LIST,
)
export const licenseeFetchFormData = ActionHelper.createActionObj(
  LICENSEE_FETCH_FORM_DATA,
)
export const licenseeChange = ActionHelper.createActionObj(LICENSEE_CHANGE)
export const licenseeDelete = ActionHelper.createActionObj(LICENSEE_DELETE)
export const licenseeClearState = ActionHelper.createActionObj(
  LICENSEE_CLEAR_STATE,
)
export const licenseeClearStateList = ActionHelper.createActionObj(
  LICENSEE_CLEAR_STATE_LIST,
)
export const licenseeClearStateForm = ActionHelper.createActionObj(
  LICENSEE_CLEAR_STATE_FORM,
)
export const licenseeFetchListByUser = ActionHelper.createActionObj(
  LICENSEE_FETCH_LIST_BY_USER,
)
export const licenseeFetchTableData = ActionHelper.createActionObj(
  LICENSEE_GET_TABLE_DATA,
)
export const licenseeUpdateLogo = ActionHelper.createActionObj(
  UPDATE_LICENSEE_LOGO,
)

// state
const initialState = fromJS({
  loading: true,
  licenseeLoader: false,
  listData: [],
  tableData: {
    data: [],
    count: 0,
  },
  licenseeData: [],
  formData: {
    licensee: {},
  },
  currentLicensee: {},
})
const loadingActive = state => state.set('loading', true)

// reducers
const licensee = handleActions(
  {
    [combineActions(
      LICENSEE_DELETE,
      LICENSEE_CHANGE,
      LICENSEE_GET_TABLE_DATA,
      LICENSEE_FETCH_FORM_DATA,
      LICENSEE_FETCH_LIST,
    )]: loadingActive,
    [LICENSEE_SET_TABLE_DATA]: (state, action) =>
      state.set('tableData', Map(action.tableData)),
    [LICENSEE_DISPLAY_TABLE]: (state, action) =>
      state.set('listData', List(action.listData)),
    [LICENSEE_DISPLAY_FORM]: (state, action) =>
      state.set('formData', Map(action.formData)),
    [combineActions(LICENSEE_CLEAR_STATE, RESET_STORE)]: () => initialState,
    [LICENSEE_CLEAR_STATE_LIST]: state =>
      state.set('tableData', initialState.get('tableData')),
    [LICENSEE_CLEAR_STATE_FORM]: state =>
      state.set('formData', initialState.get('formData')),
    [LICENSEE_REDIRECT]: state => state.set('loading', true),
    [LICENSEE_FETCH_LIST_BY_USER_SUCCESS]: (state, action) =>
      state.set('licenseeData', List(action.listData)),
    [UPDATE_LICENSEE_LOGO]: state => state.set('licenseeLoader', true),
    [UPDATE_LICENSEE_LOGO_SUCCESS]: (state, action) =>
      state
        .set('licenseeLoader', false)
        .set('currentLicensee', Map(action.payload)),
    [UPDATE_LICENSEE_LOGO_FAILURE]: state => state.set('licenseeLoader', false),
    [CLEAR_CURRENT_LICENSEE]: state =>
      state.set('currentLicensee', initialState.get('currentLicensee')),
  },
  initialState,
)

export default licensee
